import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import debounce from "lodash.debounce";

import DogHero from '../Global/DogHero';
import MayorCard from '../Global/MayorCard';
import Filters from './Filters';

import mayor from '../../assets/images/mayor.png';
import loader from '../../assets/animations/loader-b.svg';

import { getMayors, setMayorFilters, clearMayorState, setMayorType, setMayorPage, getMoreMayors } from '../../store/actions/mayorActions';

class MayorsPage extends Component {

    componentDidMount(){
        const { filters } = this.props;
        this.props.getMayors(filters);
        window.addEventListener('scroll', this.handleScroll, true)
    }

    componentDidUpdate(prevProps){
        const { type, filters } = this.props;

        if(prevProps.type !== type){
            this.props.getMayors(filters)
        }
    }

    componentWillUnmount(){
        this.props.clearMayorState();
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }


    handleScroll = debounce(async () => {
        const wrappedElement = document.getElementById('mayors');
            
            if (this.isBottom(wrappedElement) && this.props.totalMayors && this.props.mayorsShown && this.props.totalMayors !== this.props.mayorsShown) {
                await this.props.setMayorPage(this.props.page + 1);
                this.props.getMoreMayors(this.props.filters);
            }
    }, 200)

    render(){

        const { mayors, fetchingMayors, fetchingAdditionalMayors } = this.props;
        
        return (
            <React.Fragment>
                <DogHero id="mayorsHero" 
                inputPlaceholder={'Find mayors'} 
                dog={mayor} 
                titleLeft={'Pretražite'} 
                titleHighlight={'načelnike'} 
                titleRight={'Bosne i Hercegovine i pročitajte informacije o njima!'} 
                inputHidden={true}
                 />
                <div id="mayors" className="dogs">
                    <Filters />
                    <div className="results">
                        {fetchingMayors ? <img src={loader} alt="loader" className="dogs__loading" /> :
                            <React.Fragment>
                                {mayors && mayors.length ? mayors.map(mayor => {
                                    return (
                                        <Link key={mayor._id} to={`/mayors/${mayor._id}`}>
                                            <MayorCard mayor={mayor} />
                                        </Link>
                                    )
                                }) : <h1>
                                    Ne postoje gradonačelnici koji odgovaraju filterima
                                    </h1>}
                                {fetchingAdditionalMayors ? <img src={loader} alt="loader" className="dogs__loading--alternative" /> : null}
                            </React.Fragment>}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    changeCategory = (event) => {
        const { category } = this.state;
       
        if(event.target.id === category){
            this.setState({
                category: ''
            })
        }
        else {
            this.setState({
                category: event.target.id
            })
        }
    }
}


const setStateToProps = (state) => {
    return {
        mayors: state.mayors.mayors,
        fetchingMayors: state.mayors.fetchingMayors,
        type: state.mayors.type,
        filters: state.mayors.filters,
        page: state.mayors.page,
        totalMayors: state.mayors.totalMayors,
        mayorsShown: state.mayors.mayorsShown,
        fetchingAdditionalMayors: state.mayors.fetchingAdditionalMayors
    }
}
const setDispatchToProps = (dispatch) => {
    return {
        getMayors: () => { dispatch(getMayors())},
        setMayorFilters: (filters) => { dispatch(setMayorFilters(filters)) },
        clearMayorState: () => { dispatch(clearMayorState()) },
        setMayorType: (type) => { dispatch(setMayorType(type)) },
        setMayorPage: (page) => { dispatch(setMayorPage(page)) },
        getMoreMayors: (filters) => { dispatch(getMoreMayors(filters)) }
    }
}

export default connect(setStateToProps, setDispatchToProps)(MayorsPage);